import { render, staticRenderFns } from "./FooterElem.vue?vue&type=template&id=0636cb1a"
import script from "./FooterElem.vue?vue&type=script&lang=js"
export * from "./FooterElem.vue?vue&type=script&lang=js"
import style0 from "./FooterElem.vue?vue&type=style&index=0&id=0636cb1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports